import { render, staticRenderFns } from "./QuickAddBooking.vue?vue&type=template&id=c6df97d8"
import script from "./QuickAddBooking.vue?vue&type=script&lang=js"
export * from "./QuickAddBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports